import { frontendURL } from '../../../helper/URLHelper';
import ProductsIndex from './pages/ProductsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/products'),
    name: 'products_dashboard_index',
    component: ProductsIndex,
    meta: commonMeta,
  },
];
